import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    maxWidth: "300px",
    margin: "0 auto",
  },
});

export default useStyles;
